import { Link } from "react-router-dom";
import { useSeo } from "@/lib/seo";
import { SSButton } from "@/components/site/SSButton";
import { ContourField } from "@/components/site/ContourField";

export default function NotFound() {
  useSeo({ title: "Not found", description: "This page could not be found.", path: "/404" });
  return (
    <section className="relative min-h-[80vh] flex items-center overflow-hidden" data-testid="not-found">
      <ContourField className="absolute inset-0 h-full w-full opacity-40" />
      <div className="ss-container relative text-center">
        <p className="font-mono-ss text-[0.7rem] tracking-widest text-[#8A9098] mb-6">30.0668° N · 79.0193° E · UTTARAKHAND</p>
        <h1 className="font-display text-7xl sm:text-8xl lg:text-9xl font-light text-[#1A1C1E] leading-none">Off the map</h1>
        <p className="mt-6 text-lg font-light text-[#52575D] max-w-md mx-auto">This page could not be found. Let's return you to familiar ground.</p>
        <div className="mt-10 flex justify-center gap-4">
          <SSButton to="/" variant="primary">Return home</SSButton>
          <SSButton to="/intelligence" variant="secondary" arrow={false}>Explore intelligence</SSButton>
        </div>
      </div>
    </section>
  );
}
